import { IWizardStep } from "../../../../wizard/types";
import validator from "../../validators/step1/validator";
import Content from "./Content";

export const editConfigStep1: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Edit course",
  },
  content: Content,
  validator: validator,
  stepName: "step1",
};
